import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Vector3, Vector2 } from 'three';

import { WebSocketSubject } from 'rxjs/webSocket';
import { GrayImage2, GrayImage3 } from '../../image-slice-show/share/image';
import { b64ToFloat32Array } from '../utils';
import { dummyGrayImage3 } from './image.debug.repository';

const WEB_SOCKET_URL = 'ws://127.0.0.1:8081/CT/image';

// const TEST_URL = 'http://192.168.1.33:5006/api/v1/CT/file?recon_id=25';
const TEST_URL = '666';

@Injectable({ providedIn: 'root' },)
export class HttpImageLoaderService {
  public isLoadDummyData = true;
  public image3Input: GrayImage3 = dummyGrayImage3(
    new Vector3(5, 5, 5),
    new Vector3(20, 20, 20),
  );
  constructor(private http: HttpClient) {
    if (this.isLoadDummyData) {
      console.warn('Http image loader is set to load dummy data');
    }
  }
  getImageHttp(url?: string): Observable<GrayImage3> {
    if (!url) {
      url = TEST_URL;
    }
    if (this.isLoadDummyData) {
      return of(
        dummyGrayImage3(new Vector3(100, 100, 100), new Vector3(100, 100, 100)),
      );
    }
    this.http.post(url, {a: 2, b: 3}).subscribe( a => console.log(a));
    return this.http
      .get<ImageJSON>(url)
      .pipe(tap(s => console.log(s)))
      .pipe(map(jsonObjectToImage3))
      .pipe(map(reorder3));
  }
  getImage2Websocket(): Observable<GrayImage2WithWindow> {
    const result = new WebSocketSubject<ImageJSON>(WEB_SOCKET_URL);
    return result.pipe(map(r => jsonObjectToImage2WithWindow(r)));
  }
}

interface GrayImage2WithWindow {
  image: GrayImage2;
  vmin?: number;
  vmax?: number;
}

interface ImageJSON {
  size: number[];
  shape: number[];
  center: number[];
  values: string;
  vmin?: number;
  vmax?: number;
}

function jsonObjectToImage3(data: ImageJSON) {
  return new GrayImage3(
    new Vector3(...data.center),
    new Vector3(...data.size),
    new Vector3(...data.shape),
    b64ToFloat32Array(data.values),
  );
}

function jsonObjectToImage2(data: ImageJSON): GrayImage2 {
  return new GrayImage2(
    new Vector2(...data['center']),
    new Vector2(...data['size']),
    new Vector2(...data['shape']),
    b64ToFloat32Array(data['values']),
  );
}

function jsonObjectToImage2WithWindow(data: ImageJSON) {
  return { image: jsonObjectToImage2(data), vmin: data.vmin, vmax: data.vmax };
}

function reorder3(source: GrayImage3): GrayImage3 {
  const data = new Float32Array(source.data.length);
  for (let i = 0; i < source.meta.shape.x; i++) {
    for (let j = 0; j < source.meta.shape.y; j++) {
      for (let k = 0; k < source.meta.shape.z; k++) {
        const ind =
          i +
          j * source.meta.shape.y +
          k * source.meta.shape.x * source.meta.shape.y;
        data[
          i * source.meta.shape.y * source.meta.shape.z +
            j * source.meta.shape.z +
            k
        ] = source.data[ind];
        // data[ind] = source.data[ind];
      }
    }
  }
  return new GrayImage3(
    source.meta.center,
    source.meta.size,
    source.meta.shape,
    data,
  );
}
